import { render, staticRenderFns } from "./AddOrUpdateDelivery.vue?vue&type=template&id=32ec9455&scoped=true"
import script from "./AddOrUpdateDelivery.vue?vue&type=script&lang=js"
export * from "./AddOrUpdateDelivery.vue?vue&type=script&lang=js"
import style0 from "./AddOrUpdateDelivery.vue?vue&type=style&index=0&id=32ec9455&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32ec9455",
  null
  
)

export default component.exports